import React from 'react'
import { Provider } from 'react-redux'
import store, { ReduxContext } from './redux'

export const ReduxProvider = ({ children }: { children: JSX.Element }) => (
  <Provider store={store} context={ReduxContext}>
    {children}
  </Provider>
)
